import WeChatOAuth from "../plugins/WeChatOAuth";
import { $cookies } from "../plugins/cookie";
import { $api } from "../services/api";
import { $config } from "../conf";
import Cookie from "js-cookie";

const getDefaultState = () => {
  return {
    isFan: false,
    globalUserId: "",
    session: "",
    openId: "",
    unionId: "",
    token: "",
    tokenInfo: {},
    info: {
      name: "",
      phone: "",
      email: "",
      relation: "",
      company: "",
      position: "",
      industry: "",
      province: "",
      city: "",
      signUpSource: 2,
      certificateType: "", //证件类型
      certificateCode: "", //证件值
      ticketType: "", //票类型
      employeeId: "", //工号
      fromProvince: "", //出发省/直辖市
    },
    AttendanceStatus: 0, // 1: 线下会已报名（报名线下默认报名线上） banner (电子卡正) header 个人中心   2： 线上会已报名  banner (电子卡正) header （报名参会） 3： 未报名 banner (报名参会) header （报名参会）
  };
};
const state = getDefaultState();
const getters = {};
const actions = {
  init({ commit, dispatch }) {
    dispatch("loadGlobalUserId");
    let smarketMember = $cookies.smarketMember($config.schemaId);
    if (smarketMember) {
      commit("updateSession", smarketMember.session);
      commit("updateInfo", {
        memberId: smarketMember.memberId,
      });
    }
  },
  async getToken({ commit, dispatch }) {
    dispatch("loadGlobalUserId");
    const tokenInfo = Cookie.get("tur_token_info");
    if (typeof tokenInfo === "string") {
      commit("updateToken", JSON.parse(tokenInfo));
      return JSON.parse(tokenInfo);
    }
    return "";
  },
  async getUserInfo({ commit }) {
    return new Promise((resolve, reject) => {
      return $api
        .getSignUpInfo()
        .then((res) => {
          commit("updateInfo", res.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  async checkRegister({ commit }) {
    return new Promise((resolve, reject) => {
      return $api
        .checkRegister()
        .then((res) => {
          commit("updateStatus", res.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  logout({ commit, state, dispatch }) {
    // commit("RESET_STATE");
    const source = state.token.source || "";
    const smarketToken = state.token.smarketToken || "";
    if (source === "hwid") {
      $api.logout().finally((res) => {
        console.log("退出登录", res);
      });
      // 清除cookies
      Cookie.remove("tur_token", {
        expires: -1,
        path: "/",
        domain: ".huawei.com",
      });
      Cookie.remove("tur_token_info", {
        expires: -1,
        path: "/",
        domain: ".huawei.com",
      });
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } else if (source === "uniportal") {
      // uniportal 登录退出
      // 清除cookies
      Cookie.remove("tur_token", {
        expires: -1,
        path: "/",
        domain: ".huawei.com",
      });
      Cookie.remove("tur_token_info", {
        expires: -1,
        path: "/",
        domain: ".huawei.com",
      });
      Cookie.remove("logFlag", {
        expires: -1,
        path: "/",
        domain: ".huawei.com",
      });
      const { uniportalSignOut } = $config;
      window.location.href =
        uniportalSignOut +
        smarketToken +
        "&returnUrl=" +
        encodeURIComponent(window.location.href);
    } else {
      //邮箱登录退出 // 清除cookies
      Cookie.remove("tur_token", {
        expires: -1,
        path: "/",
        domain: ".huawei.com",
      });
      Cookie.remove("tur_token_info", {
        expires: -1,
        path: "/",
        domain: ".huawei.com",
      });
      Cookie.remove("logFlag", {
        expires: -1,
        path: "/",
        domain: ".huawei.com",
      });
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    }
  },

  async loadGlobalUserId({ state, commit }) {
    let globalUserId = $cookies.globalUserId();
    if (!globalUserId) {
      const globalUserIdData = await $api.onAnonymousGetId();
      globalUserId = globalUserIdData.content;
      $cookies.globalUserId(globalUserId);
    }
    commit("updateGlobalUserId", globalUserId);
    return state.globalUserId;
  },

  async checkFan({ state, commit }) {
    const fanStatusData = await $api.onWechatContactsCheck({
      openIds: [state.openId],
    });
    commit("updateIsFan", fanStatusData.content.items.length === 0);
    return state.isFan;
  },

  async getNewToken({ state, commit }) {
    const tokenData = await $api.onMemberGetTokenByOpenId({
      openId: state.openId,
      unionId: state.unionId,
    });
    const tokenInfo = { ...state.tokenInfo, token: tokenData.content.token };
    commit("updateToken", tokenInfo.token);
    return tokenInfo;
  },

  /**
   * smarket新授权获取微信信息
   * @returns {Promise<void>}
   */
  async loadWeChatInfo({ commit, dispatch }) {
    if (!$cookies.openId($config.weChatId)) {
      const token = await WeChatOAuth.getToken();
      let tokenInfo = { ...token.tokenInfo, token: token.token };
      $cookies.openId($config.weChatId, tokenInfo.providerId);
      $cookies.unionId(tokenInfo.unionId);
      commit("updateOpenId", tokenInfo.providerId);
      commit("updateUnionId", tokenInfo.unionId);
      commit("updateToken", tokenInfo.token);
      return tokenInfo;
    } else {
      commit("updateOpenId", $cookies.openId($config.weChatId));
      commit("updateUnionId", $cookies.unionId());
      await dispatch("getNewToken");
    }
  },

  /**
   * 通过微信授权自动登录
   */
  async loginFromWeChatOAuth({ state, commit, dispatch }) {
    if (!$cookies.session($config.tenantId)) {
      return $api
        .onMemberLogin({
          verify: state.token,
        })
        .then((memberInfo) => {
          $cookies.session($config.tenantId, memberInfo.content.session, {
            expires: 5,
            path: "/",
          });
          commit("updateSession", memberInfo.content.session);
          return memberInfo.content;
        });
    } else {
      commit("updateSession", $cookies.session($config.tenantId));
    }
  },
};
const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState());
  },
  updateGlobalUserId(state, globalUserId) {
    state.globalUserId = globalUserId;
  },
  updateToken(state, token) {
    state.token = token;
  },
  updateOpenId(state, openId) {
    state.openId = openId;
  },
  updateUnionId(state, unionId) {
    state.unionId = unionId;
  },
  updateSession(state, session) {
    state.session = session;
  },
  updateIsFan(state, isFan) {
    state.isFan = isFan;
  },
  updateInfo(state, info) {
    state.info.name = info.fullName;
    state.info.phone = info.mobilePhone;
    state.info.email = info.email;
    state.info.relation = info.hwRelation;
    state.info.company = info.company;
    state.info.position = info.firstPosition
      ? info.firstPosition +
        (info.secondPosition ? "/" + info.secondPosition : "")
      : "";
    state.info.industry = info.industryl1
      ? info.industryl1 + (info.industryl2 ? "/" + info.industryl2 : "")
      : "";
    state.info.province = info.state;
    state.info.city = info.city;
    state.info.signUpSource = info.signUpSource;
    state.info.certificateType = info.certificateType;
    state.info.certificateCode = info.certificateCode;
    state.info.ticketType = info.ticketType;
    state.info.employeeId = info.employeeId;
    state.info.fromProvince = info.fromProvince;
  },
  updateStatus(state, AttendanceStatus) {
    state.AttendanceStatus = AttendanceStatus;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
